// @flow

import styled from 'styled-components';
import COLORS from 'client/constants/colors';

export const DividerNoMargin = styled.hr`
  border-top: 0px solid ${COLORS.GRAY_3};
`;

const Divider = styled(DividerNoMargin)`
  margin-bottom: 1rem;
`;

export default Divider;
